import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import debounce from "lodash.debounce";

import api from "api";
import WP from "WP";
import { currentLanguage } from "helpers";

import Container from "partials/Container";
import GridElement from "partials/GridElement";
import SmartLink from "partials/SmartLink";

import GreenLogo from "icons/FooterLogo";
import Smartphone from "icons/SmartphoneIcon";
import Envelope from "icons/EnvelopeIcon";
import Facebook from "icons/FacebookIcon";
import Instagram from "icons/InstagramIcon";
import Youtube from "icons/YoutubeIcon";

import theme from "css/theme";
import Media, { ScreenWidth } from "css/Media";

class Footer extends Component {
  componentWillMount() {
    this.checkScreenSize();
  }

  componentDidMount() {
    window.addEventListener(
      "resize",
      debounce(() => this.checkScreenSize()),
      500
    );
    api.getMenuByLocation("footer_menu");
    api.getMenuByLocation("footer_links");
  }

  checkScreenSize() {
    let isMobile = false;
    if (ScreenWidth.lessThan("s")) {
      isMobile = true;
    }

    this.setState({ isMobile });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  }

  render() {
    const { footerMenu, footerLinks } = this.props;
    const { isMobile } = this.state;

    return (
      <Wrapper>
        <Container
          grid
          rows={
            isMobile
              ? "60px repeat(6, auto) 100px"
              : "95px repeat(4, auto) 220px"
          }
        >
          <GridElement
            colStart={{ default: 1, s: 1, l: 3 }}
            colEnd={{ default: 8, s: 11, l: 10 }}
            rowStart={2}
          >
            <Title>{WP.trans.title}</Title>
          </GridElement>
          <GridElement
            colStart={{ default: 1, s: 1, l: 3 }}
            colEnd={{ default: 8, s: 11, l: 10 }}
            rowStart={3}
          >
            <StyledText>
              {WP.trans.footerText}{" "}
              <a href={currentLanguage() === "no" ? "/om-oss" : "/en/about-us"}>
                {WP.trans.moreAboutUs}
              </a>
            </StyledText>
          </GridElement>
          <GridElement
            colStart={{ default: 1, s: 1, l: 3 }}
            colEnd={{ default: 8, s: 11, l: 10 }}
            rowStart={4}
          >
            <FooterContact>
              <Adress>
                <Smartphone />
                <a id='phonenumber' href={`tel: ${WP.options.footer_phone}`}>
                  {WP.options.footer_phone}
                </a>
              </Adress>
              <Adress>
                <Envelope />
                <a
                  href={`mailto:${WP.trans.salesEmailAdress}`}
                  style={{
                    color: theme.button,
                    textDecoration: "underline",
                  }}
                >
                  {WP.trans.salesEmailAdress}
                </a>
              </Adress>
            </FooterContact>
          </GridElement>
          <GridElement
            colStart={{ default: 1, s: 1, l: 3 }}
            colEnd={{ default: 8, s: 11, l: 10 }}
            rowStart={{ default: 7, s: 5 }}
          >
            <FooterSoMe>
              <StyledA target='_blank' href={WP.options.footer_fb_link}>
                <Facebook />
                {isMobile ? "" : "Facebook"}
              </StyledA>
              <StyledA target='_blank' href={WP.options.footer_instagram_link}>
                <Instagram />
                {isMobile ? "" : "Instagram"}
              </StyledA>
              <StyledA
                target='_blank'
                href='https://www.youtube.com/channel/UChLRA01sqQ0QZdzix6yQWWw'
              >
                <Youtube />
                {isMobile ? "" : "YouTube"}
              </StyledA>
            </FooterSoMe>
          </GridElement>
          <GridElement
            colStart={{ default: 1, s: 14, l: 13 }}
            colEnd={{ default: 8, s: 19, l: 18 }}
            rowStart={{ default: 5, s: 2 }}
            rowEnd={{ default: 6, s: 6 }}
          >
            <FooterMenu>
              {footerMenu.map((item) => {
                return (
                  <li key={item.id}>
                    <SmartLink to={item.url}>{item.title}</SmartLink>
                  </li>
                );
              })}
            </FooterMenu>
          </GridElement>
          <GridElement
            colStart={{ default: 1, s: 19 }}
            colEnd={{ default: 8, s: 24 }}
            rowStart={{ default: 6, s: 2 }}
            rowEnd={{ default: 7, s: 6 }}
          >
            <FooterLinks>
              {footerLinks.map((link, idx) => {
                return (
                  <li key={idx}>
                    <SmartLink to={link.url}>{link.title}</SmartLink>
                  </li>
                );
              })}
            </FooterLinks>
          </GridElement>
        </Container>
        <StyledLogo />
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  footerMenu: state.menus[WP.lang].footer_menu
    ? state.menus[WP.lang].footer_menu.items
    : [],
  footerLinks: state.menus[WP.lang].footer_links
    ? state.menus[WP.lang].footer_links.items
    : [],
});

export default connect(mapStateToProps, null)(Footer);

const Wrapper = styled.footer`
  background-color: ${(props) => props.theme.colors.bgLight};
  position: relative;
  overflow: hidden;

  .container {
    z-index: 2;
    height: 100%;
  }
`;

const Title = styled.span`
  display: block;
  ${(props) => props.theme.fonts.h3};
  margin-bottom: ${(props) => props.theme.spacing.contentS};

  ${Media.lessThan("s")`
        font-size: 20px;
        line-height: 22px;
    `}
`;

const StyledText = styled.p`
  margin-bottom: ${(props) => props.theme.spacing.elementXS};

  a {
    color: ${(props) => props.theme.colors.link};
    text-decoration: underline;
  }

  ${Media.lessThan("s")`
            font-size: 14px;
            line-height: 22px;
    `}

  ${Media.greaterThan("s")`
        margin-bottom: ${(props) => props.theme.spacing.elementS};
    `}

    ${Media.greaterThan("l")`
        margin-bottom: ${(props) => props.theme.spacing.elementS};
    `}
`;

const FooterContact = styled.div`
  margin-bottom: ${(props) => props.theme.spacing.elementM};

  span {
    ${(props) => props.theme.fonts.p};
  }

  ${Media.lessThan("s")`
        span, a {
            font-size: 14px;
            line-height: 22px;
        }
    `}
`;

const Adress = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing.contentS};

  svg {
    margin-right: ${(props) => props.theme.spacing.contentXS};
  }
`;

const StyledA = styled.a`
  display: flex;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing.contentS};
  margin-right: ${(props) => props.theme.spacing.contentXL};

  svg {
    margin-right: ${(props) => props.theme.spacing.contentXS};
  }
`;

const FooterSoMe = styled.div`
  display: flex;
`;

const FooterMenu = styled.ul`
  margin-bottom: ${(props) => props.theme.spacing.elementXS};

  li {
    ${(props) => props.theme.fonts.h5};
    padding-bottom: ${(props) => props.theme.spacing.contentS};

    &:hover {
      text-decoration: underline;
    }

    ${Media.lessThan("s")`
            font-size: 18px;
            line-height: 36px;
            padding-bottom: ${(props) => props.theme.spacing.contentXS};
        `}
  }

  ${Media.greaterThan("s")`
        margin-bottom: 0;
    `}
`;

const FooterLinks = styled.ul`
  margin-bottom: ${(props) => props.theme.spacing.elementXS};

  li {
    padding-bottom: ${(props) => props.theme.spacing.contentXS};

    &:hover {
      text-decoration: underline;
    }

    ${Media.lessThan("s")`
            padding-bottom: ${(props) => props.theme.spacing.contentS};
        `}
  }

  ${Media.greaterThan("s")`
        margin-bottom: 0;
    `}
`;

const StyledLogo = styled(GreenLogo)`
  position: absolute;
  top: -100px;
  right: 0;
  bottom: 0;
  transform: translate(50%, -15%) scale(0.7);

  ${Media.greaterThan("s")`
        transform: translate(50%, -10%);
    `}
`;
